import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {tntBlue, tntFadedBlue} from '../../../../../../../../../../../../theme/tntColors';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import {Link} from 'react-router-dom';
import Radium from 'radium';
import auth from '../../../../../../../../../../../../services/auth';
import logo from './img/touchandtell-logo.png';

const styles = {
  header: {
    backgroundColor: tntBlue,
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    boxSizing: 'border-box',
    minWidth: 1240,
    padding: '0 24px',
  },
  logoWrapper: {
    display: 'inline-block',
    margin: '8px 0 3px',
  },
  logo: {
    height: '50px',
  },
  emailWrapper: {
    float: 'right',
    marginTop: '13px',
  },
  emailButton: {
    height: 'auto',
    paddingBottom: 1,
  },
  emailButtonLabel: {
    textTransform: 'none',
    color: 'white',
  }
}

@injectIntl
@Radium
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  openPopover = (event) => {
    event.preventDefault(); // Prevents ghost click.
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  closePopover = () => {
    this.setState({
      open: false,
    });
  };

  logout = () => {
    auth.logout();
  };

  render() {
    const viewer = this.props.viewer;
    return (
      <div>
        <div style={styles.header}>
          <div style={styles.logoWrapper}>
            <Link to={`/${this.props.history.location.search}`}>
              <img src={logo} alt="Touch&Tell" style={styles.logo} />
            </Link>
          </div>
          <div style={styles.emailWrapper}>
            <FlatButton
              onTouchTap={this.openPopover}
              label={viewer.email}
              style={styles.emailButton}
              labelStyle={styles.emailButtonLabel}
              hoverColor={tntFadedBlue}
            />
          </div>
        </div>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={this.closePopover}
        >
          <Menu>
            <MenuItem
              primaryText={this.props.intl.formatMessage({id: 'logOut'})}
              onTouchTap={this.logout}
            />
          </Menu>
        </Popover>
      </div>
    )
  }
}

export default createFragmentContainer(
  Header,
  graphql`
    fragment Header_viewer on Viewer {
      email
    }
  `,
);



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/components/RoutesContainer/components/Header/Header.js